import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  viewBox: "0 0 13 11",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.71 0a.5.5 0 0 0-.357.139.5.5 0 0 0-.013.707L11.326 5H.5a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h10.826L7.34 10.154a.5.5 0 0 0 .013.707.5.5 0 0 0 .708-.015l4.785-4.985.015-.015a.5.5 0 0 0 .047-.074.5.5 0 0 0 .051-.082.5.5 0 0 0 .021-.092.5.5 0 0 0 .018-.094A.5.5 0 0 0 13 5.5a.5.5 0 0 0 0-.004.5.5 0 0 0-.014-.068.5.5 0 0 0-.006-.026.5.5 0 0 0-.013-.078.5.5 0 0 0-.002-.006.5.5 0 0 0-.008-.017.5.5 0 0 0 0-.002.5.5 0 0 0-.025-.035.5.5 0 0 0-.034-.051.5.5 0 0 0-.037-.059l-.008-.007a.5.5 0 0 0-.003-.004.5.5 0 0 0-.004-.004L8.06.154A.5.5 0 0 0 7.71 0z",
      fill: "#1f1f1f"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "arrow-short"}) } }